<template>
  <div>
    <b-modal v-model="showModal" ref="alertModal" hide-header hide-footer centered>
      <div class="modal-header">
        <button type="button" aria-label="Close" class="close" @click="hide">×</button>
      </div>
      <div class="text-center p-3" v-if="item">
        <img :src="item.banner.banner.imageUrl" class="img-banner d-none d-sm-block" />
        <img :src="item.banner.banner.mobileImageUrl" class="img-banner d-sm-none" />
        <h3 class="mb-0">{{$t("textSystemMaintenance1")}}</h3>
        <p class="text-text">{{$t("textSystemMaintenance2")}}</p>
        <p class="text-text">{{$t("textSystemMaintenance3")}}</p>
        <p class="text-text">{{textDate}}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import * as moment from "moment/moment";

export default {
  props: {
    item: {
      required: false,
      type: Object
    }
  },
  data() {
    return {
      showModal: false,
      textDate: "",
    };
  },
  methods: {
    show() {
      if(moment(this.item.banner.banner.startDate).format(this.$formatDate) == moment(this.item.banner.banner.endDate).format(this.$formatDate)){
        this.textDate = `${this.$t("textSystemMaintenanceOnDate")} ${moment(this.item.banner.banner.startDate).format(this.$formatDate)} ${this.$t("textSystemMaintenanceOnTime1")} ${moment(this.item.banner.banner.startDate).format(this.$formatTime)} - ${moment(this.item.banner.banner.endDate).format(this.$formatTime)} ${this.$t("textSystemMaintenanceOnTime2")}`
      }else{
        this.textDate = `${this.$t("textSystemMaintenanceOnDate")} ${moment(this.item.banner.banner.startDate).format(this.$formatDate)} ${this.$t("textSystemMaintenanceOnTime1")} ${moment(this.item.banner.banner.startDate).format(this.$formatTime)} - ${moment(this.item.banner.banner.endDate).format(this.$formatDate)} ${moment(this.item.banner.banner.endDate).format(this.$formatTime)} ${this.$t("textSystemMaintenanceOnTime2")}`
      }
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    }
  },
};
</script>

<style scoped>
.modal-header {
  border: 0 !important;
  padding: 0;
}
.text-text {
  color: #16274a;
  margin-bottom: 0;
  font-size: 20px;
  line-height: 1.2;
}
.modal-body {
  margin: auto;
  text-align: center;
}
.img-banner {
  width: 100%;
  margin-bottom: 15px;
}
@media (max-width: 767.98px) {
  .text-text {
    font-size: 15px;
  }
}
</style>